<template>
    <div>
        <DataTable class="devices-report-data-table"
                   :dataUrl="dataUrl"
                   :displayId="false"
                   :key="tableRefreshKey"
                   :dataFormatter="formatData"
                   :sortable="false"
                   @actionTriggered="actionTriggered">

            <template v-slot:empty>
                No records found
            </template>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "@/components/global/DataTable.vue";
const endpoint = process.env.VUE_APP_API_BASE + '/activities/devices-report'

export default {
    name: 'DevicesReport',
    components: {DataTable},
    data: function() {
        return {
            dataUrl: endpoint,
            tableRefreshKey: null,
        }
    },
    methods: {
        formatData(data) {
            const newData = []
            for (let obj of data) {
                const newObj = {}
                //const ignore = ['__v', 'address', 'website', 'isEnabled', 'createdAt', 'updatedAt']
                const columns = ['_id', 'lastActivityDate', 'isUninstalled']

                for (let key of columns) {
                    if (key === '_id') {
                        newObj['id'] = {
                            'label': 'device ID',
                            'value': obj[key],
                            'display_type': 'text'
                        }
                    }
                    else if (key === 'isUninstalled') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key] ? 1 : 0,
                            'display_type': 'text'
                        }
                    }
                    else if (key === 'lastActivityDate') {
                        newObj[key] = {
                            'label': key,
                            'value': obj[key],
                            'display_type': 'date'
                        }
                    }
                }

                newData.push(newObj)
            }
            return newData
        }
    }
}
</script>

<style lang="scss" scoped>

</style>